export const FETCH_TOGGLE_VALUES_STARTED = 'FETCH_TOGGLE_VALUES_STARTED';
export const FETCH_TOGGLE_VALUES_SUCCEEDED = 'FETCH_TOGGLE_VALUES_SUCCEEDED';
export const TOGGLE_VALUES_SET = 'TOGGLE_VALUES_SET';
export const TOGGLE_VALUES_RESET = 'TOGGLE_VALUES_RESET';
